import * as React from 'react';
import { connect } from 'react-redux';
import { editUsuario, fetchUsuarios } from '../../actions/usuariosActions';
import { confirmarMfaApi, desenlazarMfaUsuarioApi, enlazarMfaUsuarioApi } from '../../api/axios';
import { setMfaStatus } from '../../actions/generalActios';
import { Modal } from 'bootstrap';
import { toast } from 'react-toastify';

class Contraseña extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            idSeller: this.props.seller.codigo,
            passwordActual: "",
            codigoQR: null,
            codigoDobleAutenticacion: "",
        };
        this.passwordActualInputRef = React.createRef();
        this.modalInstance = null;
    };

    componentDidMount() {
        this.props.fetchUsuarios(this.state);

        if (this.passwordActualInputRef.current) {
            this.passwordActualInputRef.current.focus();
        }
    }

    changePassword = (e) => {
        let usuario = {
            ...this.props.usuario,
            nuevoPassword: e.target.value,
            idSeller: this.props.seller.codigo,
            idUsuario: this.props.idUsuario[0].idUsuario
        }
        this.props.editUsuario({
            ...usuario,
            nuevoPassword: e.target.value,
            idSeller: this.props.seller.codigo,
            passwordActual: this.state.passwordActual
        });
    }

    confirmarPassword = (e) => {
        let usuario = this.props.usuario;
        this.props.editUsuario({ ...usuario, confirmarPassword: e.target.value });
    }

    passwordActual = (e) => {
        this.setState({ passwordActual: e.target.value });
    }

    onGenerarQR = async (e) => {
        e.preventDefault();

        const { userId, userCredentials } = this.props;

        let requestEnlazarMfa = {
            idUsuario: userId,
            usuario: userCredentials.user,
            password: userCredentials.password
        };

        return enlazarMfaUsuarioApi(requestEnlazarMfa)
            .then((res) => {
                this.setState({ codigoQR: res.codigoQrEnlace });
            });
    };

    onConfirmarMfa = (e) => {
        e.preventDefault();

        const { userId } = this.props;
        const { codigoDobleAutenticacion } = this.state;

        const requestConfirmarMfa = {
            idUsuario: userId,
            codigo: codigoDobleAutenticacion,
        };

        if (!codigoDobleAutenticacion.trim()) {
            toast.error("El código no puede estar vacío");
            this.setState({ codigoDobleAutenticacion: "" });
            return;
        }

        const regexCodigo = /^\d{6}$/;
        if (!regexCodigo.test(codigoDobleAutenticacion)) {
            toast.error("El código debe contener exactamente 6 dígitos numéricos");
            this.setState({ codigoDobleAutenticacion: "" });
            return;
        }

        confirmarMfaApi(requestConfirmarMfa)
            .then(() => {
                toast.success("Código confirmado correctamente");

                setTimeout(() => {
                    if (this.modalInstance) {
                        this.modalInstance.hide();
                    }

                    this.setState({
                        codigoDobleAutenticacion: ""
                    });

                    this.props.setMfaStatus(true, true);
                }, 2000);
            })
            .catch((error) => {
                console.error("Error al confirmar MFA:", error);
                toast.error("El código ingresado es incorrecto");
                this.setState({
                    codigoDobleAutenticacion: ""
                });
            });
    };

    handleChange = (e) => {
        this.setState({ codigoDobleAutenticacion: e.target.value });
    };

    onDeshabilitarMfa = (e) => {
        e.preventDefault();

        const { userId, userCredentials } = this.props;

        const requestDesenlazar = {
            idUsuario: userId,
            usuario: userCredentials.user,
            password: userCredentials.password
        };

        desenlazarMfaUsuarioApi(requestDesenlazar)
            .then(() => {
                this.props.setMfaStatus(false, false);
                toast.success("MFA revertido automáticamente");
            })
            .catch((error) => {
                toast.error("Error al desenlazar MFA automáticamente");
            });
    }

    render() {
        const { codigoQR } = this.state;

        return (
            <div className="tab-pane p-20 active" name="datos" id="home2" role="tabpanel">
                <div className="row">
                    <div className="col-sm-12 col-md-6 col-lg-6">

                        <div className="form-group">
                            <label>Contraseña actual</label>
                            <input
                                type="password"
                                className="form-control"
                                value={this.state.passwordActual}
                                onChange={this.passwordActual}
                                placeholder=""
                                name="passwordActual"
                                ref={this.passwordActualInputRef}
                            />
                        </div>

                        <div className="form-group">
                            <label>Nueva contraseña</label>
                            <input
                                type="password"
                                className="form-control"
                                value={this.props.usuario.nuevoPassword}
                                onChange={this.changePassword}
                                placeholder=""
                                name="nuevoPassword"
                            />
                        </div>

                        <div className="form-group">
                            <label>Confirmar contraseña</label>
                            <input
                                type="password"
                                className={this.props.usuarioError ? "warning-input form-control" : "form-control"}
                                value={this.props.usuario.confirmarPassword}
                                onChange={this.confirmarPassword}
                                placeholder=""
                                name="confirmarPassword"
                            />
                        </div>

                        <div className="modal fade" id="modalQrMfa" tabIndex="-1" aria-hidden="true">
                            <div className="modal-dialog modal-dialog-centered">
                                <div className="modal-content text-center px-4 pt-3 pb-4">

                                    <div className="text-end">
                                        <button
                                            type="button"
                                            className="btn-close"
                                            data-bs-dismiss="modal"
                                            aria-label="Cerrar"
                                        ></button>
                                    </div>

                                    <div className="modal-body">
                                        <p className="mb-3 fw-bold">Escaneá este QR con tu app de autenticación</p>
                                        <img
                                            src={`data:image/png;base64,${this.state.codigoQR}`}
                                            alt="QR de autenticación"
                                            style={{ width: 256, height: 256 }}
                                            className="mb-3"
                                        />
                                        <small className="text-muted d-block mb-3">
                                            Si no tenés la app, descargá
                                            <a href="https://play.google.com/store/apps/details?id=com.azure.authenticator" target="_blank" rel="noopener noreferrer">
                                                {" "}Microsoft Authenticator para Android
                                            </a>{" "}
                                            o{" "}
                                            <a href="https://apps.apple.com/app/microsoft-authenticator/id983156458" target="_blank" rel="noopener noreferrer">
                                                iOS
                                            </a>.
                                        </small>

                                        <input
                                            required
                                            name="codigoDobleAutenticacion"
                                            type="text"
                                            className="form-control mb-3 text-center"
                                            placeholder="Ingresá el código de 6 dígitos"
                                            onChange={this.handleChange}
                                            maxLength={6}
                                            value={this.state.codigoDobleAutenticacion}
                                        />

                                        <button
                                            onClick={this.onConfirmarMfa}
                                            className="btn btn-large background-rojo-megatone rounded-sm"
                                        >
                                            Enviar código
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {this.props.mfaStatus?.mfaHabilitado && this.props.mfaStatus?.mfaConfirmado ? (
                            <button
                                onClick={this.onDeshabilitarMfa}
                                className="btn btn-large background-rojo-megatone rounded-sm"
                            >
                                Deshabilitar doble factor de autenticación
                            </button>
                        ) : (
                            <>
                                <button
                                    onClick={(e) => {
                                        this.setState({ codigoDobleAutenticacion: "", codigoQR: null }, () => {
                                            this.onGenerarQR(e).then(() => {
                                                const modalElement = document.getElementById("modalQrMfa");
                                                this.modalInstance = new Modal(modalElement);
                                                this.modalInstance.show();
                                            });
                                        });
                                    }}
                                    className="btn btn-large background-rojo-megatone rounded-sm"
                                >
                                    Habilitar doble factor de autenticación
                                </button>

                                <a
                                    href="/manual_mfa.html"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-large btn-outline-secondary rounded-sm ms-2"
                                    style={{ marginLeft: '10px' }}
                                    title="Ayuda"
                                >
                                    <i className="mdi mdi-help-circle-outline"></i>
                                </a>
                            </>
                        )}
                    </div>
                </div>
            </div >
        );
    }
}

const mapStateToProps = state => ({
    tipoUsuario: state.general.tipoUsuario,
    usuario: state.usuarios.usuario,
    usuarioError: state.usuarios.error,
    idUsuario: state.usuarios.usuarios,
    seller:
        JSON.stringify(state.general.generalObject) != "{}"
            ? state.general.generalObject
            : state.sellers.seller
    ,
    userId: state.general.userId,
    userCredentials: state.general.userCredentials,
    mfaStatus: state.general.mfaStatus,
});

export default connect(mapStateToProps, { editUsuario, fetchUsuarios, setMfaStatus })(Contraseña); 